import faixaMetadata from './data/faixa-metadata.json';
import type { CepFaixaDataVersion } from './faixa-types.js';

export const CEP_FAIXA_DATA_VERSION: CepFaixaDataVersion = faixaMetadata as CepFaixaDataVersion;
